import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twMerge } from 'tailwind-merge';
import { useNotifications } from '../hooks/use-notifications';
import UnreadIndicator from './unread-indicator';
import { useOpenNotificationMenuQuery } from '../hooks/use-open-notification-menu-query';
import { BellIcon } from '@systemeio/ui/icons';
import { useActualHeaderLayoutType } from 'shared/components/header';
import { NotificationsMenuContent } from './notifications-menu-content';
export interface NotificationMenuProps {
  className?: string;
}
const defaultFilter = {
  onlyUnRead: false
};
export const NotificationMenuMobile = t0 => {
  const $ = _c(32);
  const {
    className
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMenuOpen(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleMenuState = t1;
  const {
    pagination
  } = usePagination(true);
  let t2;
  if ($[1] !== pagination) {
    t2 = {
      shouldFetchNotifications: false,
      limit: 3,
      pagination,
      filter: defaultFilter
    };
    $[1] = pagination;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    notificationsMeta
  } = useNotifications(t2);
  const {
    isDesktop
  } = useActualHeaderLayoutType();
  const t3 = isDesktop === false;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      allowCheck: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    openThroughQuery
  } = useOpenNotificationMenuQuery(t4);
  let t5;
  let t6;
  if ($[5] !== openThroughQuery) {
    t5 = () => {
      if (openThroughQuery) {
        setIsMenuOpen(true);
      }
    };
    t6 = [openThroughQuery];
    $[5] = openThroughQuery;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  const t7 = isMenuOpen && "fill-background-secondary stroke-background-secondary";
  let t8;
  if ($[8] !== t7) {
    t8 = twMerge("fill-text-secondary stroke-text-secondary hover:fill-background-secondary hover:stroke-background-secondary transition", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <BellIcon className={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== notificationsMeta?.hasUnread) {
    t10 = notificationsMeta?.hasUnread && <UnreadIndicator className="absolute right-0 top-0 p-0" />;
    $[12] = notificationsMeta?.hasUnread;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <button onClick={toggleMenuState} className="focus-visible:border-brand-primary flex h-full items-center justify-around gap-2.5 border-b-4 border-transparent focus:outline-hidden"><div className="text-background-secondary/90 relative w-5 text-sm font-bold">{t9}{t10}</div></button>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="fixed inset-0 bg-black/30" aria-hidden="true" />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== className) {
    t13 = twMerge("bg-background-secondary relative w-full transform text-left shadow-xl transition-all", className);
    $[18] = className;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <NotificationsMenuContent />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13) {
    t15 = <div className="fixed inset-0 z-10 overflow-y-auto"><div className="flex w-full pt-[69px]"><TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enterTo="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 translate-y-0 sm:scale-100" leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"><DialogPanel className={t13}>{t14}</DialogPanel></TransitionChild></div></div>;
    $[21] = t13;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== isMenuOpen || $[24] !== t15) {
    t16 = <Dialog open={isMenuOpen} onClose={toggleMenuState}>{t12}{t15}</Dialog>;
    $[23] = isMenuOpen;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== isMenuOpen || $[27] !== t16) {
    t17 = <Transition show={isMenuOpen} as={Fragment}>{t16}</Transition>;
    $[26] = isMenuOpen;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t11 || $[30] !== t17) {
    t18 = <>{t11}{t17}</>;
    $[29] = t11;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  return t18;
};
function _temp(prevState) {
  return !prevState;
}